enum UsageStatsType {
  "BYTES" = "bytes",
  "REQUESTS" = "requests",
  "FILES" = "files",
  "DOCUMENTS" = "documents",
  "QUERIES" = "queries",
  "FORMS" = "forms",
}

// eslint-disable-next-line no-redeclare
namespace UsageStatsType {
  export const display = (
    type: UsageStatsType,
    withSuffix: boolean,
    value?: number
  ) => {
    const valueString = value !== undefined ? value.toString() : "∞";
    switch (type) {
      case UsageStatsType.BYTES:
        return `${valueString ? ((value || 0) / 1024 / 1024).toFixed(2) : "∞"}${
          withSuffix ? " MB" : ""
        }`;
      case UsageStatsType.REQUESTS:
        return `${valueString}${withSuffix ? " requests" : ""}`;
      case UsageStatsType.FILES:
        return `${valueString}${withSuffix ? " files" : ""}`;
      case UsageStatsType.DOCUMENTS:
        return `${valueString}${withSuffix ? " documents" : ""}`;
      case UsageStatsType.QUERIES:
        return `${valueString}${withSuffix ? " queries" : ""}`;
      case UsageStatsType.FORMS:
        return `${valueString}${withSuffix ? " forms" : ""}`;
      default:
        return valueString.toString();
    }
  };
}

export { UsageStatsType };
